import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SearchByBarcode from "./SearchByBarcode"
import SearchByLocationType from "./SearchByLocationType"
import SearchByShipmentStatus from './SearchByShipmentStatus'
import FilterDatePacking from "./FilterDatePacking"
import SearchNumberBox from './SearchNumberBox'
import Export from './actions/Export'
import SearchByPartner from './SearchByPartner'

class NextItemFilter extends Component {
    _handleSubmit = e => {
        e.preventDefault()
        if (this.props.loading) return false

        this.props.onSubmit()
    }

    render() {
        const {filter} = this.props

        return (
            <div className="NextItemFilter d-flex justify-content-between align-content-center">
                <form onSubmit={this._handleSubmit} className="d-flex justify-content-between align-content-center NextItemForm">
                    <div className="Left d-flex align-items-center NextItemFormWrap">
                        <SearchByBarcode {...this.props}/>
                        <SearchByLocationType  {...this.props}/>
                        <SearchByShipmentStatus {...this.props}/>
                        <SearchNumberBox {...this.props}/>
                        <SearchByPartner {...this.props}/>
                        <FilterDatePacking
                            {...this.props}
                            label="Thời gian đóng gói"
                            fieldTo='created[to]'
                            fieldFrom='created[from]'
                        />
                        <FilterDatePacking 
                            {...this.props}
                            label="Ngày đóng thùng"
                            fieldTo='closed[to]'
                            fieldFrom='closed[from]'
                        />
                        <FilterDatePacking
                            {...this.props}
                            label="Ngày ship"
                            fieldTo='shipped[to]'
                            fieldFrom='shipped[from]'
                        />
                    </div>
                </form>
                <div className="Right">
                    <Export filter={filter}/>
                </div>
            </div>
        )
    }
}

NextItemFilter.propTypes = {
    total: PropTypes.number.isRequired,
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default NextItemFilter